var hidden;
var visibilityChange;
var DEFAULT_TIMEOUT = 5000;
// 当点击唤端后，定时器延时n秒后判断是否唤端成功
// 唤端有个弹框需要用户点击，时间设置5s
var timeStamp;
/**
 * 获取隐藏属性和改变可见属性的事件的名称
 * @returns
 */
function getSupportedProperty(document) {
  if (typeof document === 'undefined') return;
  if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.mozHidden !== 'undefined') {
    hidden = 'mozHidden';
    visibilityChange = 'mozvisibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
}
getSupportedProperty(document);
/**
 * 判断页面是否隐藏
 * @returns
 */
function isPageHidden() {
  if (!hidden) return false;
  return document[hidden];
}
/**
 * 检测是否唤端成功
 * @param fallback // 唤端失败的回调函数
 * @param timeout
 */
var timer;
export function checkCallAppSuccess(fallback, timeout) {
  timeStamp = +new Date();
  timer = setTimeout(function () {
    var pageHidden = isPageHidden();
    if (!pageHidden && fallback) {
      fallback();
    }
  }, timeout || DEFAULT_TIMEOUT);
}
/**
 * 监听页面
 */
export function addEventListener(options) {
  if (typeof visibilityChange !== 'undefined') {
    document.addEventListener(visibilityChange, function () {
      return handlePageHidden(options);
    });
  } else {
    window.addEventListener('pagehide', function () {
      return handlePageHidden(options);
    });
  }
}
function handlePageHidden(options) {
  var evokeAppBy = options.evokeAppBy;
  if (evokeAppBy === null || evokeAppBy === void 0 ? void 0 : evokeAppBy.url) {
    handleSuccessCb(options);
    clearTimer();
  }
}
/**
 * 处理成功的回调
 * @param successCb
 */
function handleSuccessCb(_ref) {
  var evokeAppBy = _ref.evokeAppBy,
    successCb = _ref.successCb,
    timeout = _ref.timeout;
  if (successCb) {
    // hack:
    // 当小于 timeout 时，页面发生hidden，默认为唤端成功
    var newTimeStamp = +new Date();
    var newTimeout = timeout || DEFAULT_TIMEOUT;
    var preTimeStamp = timeStamp || +new Date();
    if (newTimeStamp - preTimeStamp < newTimeout) {
      successCb(evokeAppBy);
    }
  }
}
/**
 * 清除定时器
 */
function clearTimer() {
  if (timer) {
    clearTimeout(timer);
  }
}
/**
 * 判断url是不是http或者应用市场的链接
 * @param  {[type]}  url
 * @return {Boolean}     [description]
 */
export function checkIsHttpUrl(url) {
  return /^(http|https|itms-apps|itms-appss|market):\/\//.test(url);
}